import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Alert from './Alert';
import { getDefaultFallbackPath } from './PermissionsChecker';

const NOT_FOUND_ALERT_DURATION = 7000;

/**
 * Catch-all for unknown routes.
 *
 * Replicates the behaviour the Sidebar used to apply to the whole application:
 * show the notice and redirect to the role based fallback path.
 *
 * Every module must close its `<Switch>` with this component. Without it, an
 * unknown URL under the module prefix never reaches the shell catch-all and
 * renders a blank screen.
 */
export default function NotFoundRedirect () {
    const history = useHistory();
    const { t } = useTranslation();

    useEffect(() => {
        Alert.error(t('errors.pageNotFound'), NOT_FOUND_ALERT_DURATION);
        history.push(getDefaultFallbackPath());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return null;
}
